<template>
  <validation-observer ref="simpleRules">
    <item-form />
    <save-button
      :save-action="submitForm"
      :is-disabled="submitStatus"
    />
  </validation-observer>
</template>
<script>
import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import ItemForm from '@/views/Admin/Donation_groups/Expenses/ItemForm.vue'
import SaveButton from '@/layouts/components/common/SaveButton.vue'
import toastMixin from '@/libs/toast'

export default {
  name: 'Add',
  components: {
    ItemForm,
    SaveButton,
    ValidationObserver,
  },
  mixins: [toastMixin],
  data() {
    return {
      required,
      submitStatus: false,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['donationGroups/dataItem']
    },
    saveData() {
      return this.$store.getters['donationGroups/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({ template: 'saveSuccess' })
      } else if (val.status === false) {
        this.showToast({ template: 'saveError' })
      }
    },
  },
  created() {
    this.getData()
    localize('tr')
  },
  methods: {
    getData() {
      this.$store.dispatch('donationGroups/getDataItem', this.$route.params.id)
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitStatus = true
          this.$store.dispatch('donationGroups/saveData', this.dataItem)
        } else {
          this.showToast({ template: 'requireWarning' })
        }
      })
    },
  },
}
</script>
